"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MIN_WIDTH = '1280px';
//# sourceMappingURL=const.js.map